import Layout from '@/views/universe/Layout.vue';

export default {
    path: '/universe',
    component: Layout,
    children: [
        { path: 'list', component: () => import('@/views/universe/StockUniverse.vue') },
        { path: 'corporate-events', component: () => import('@/views/universe/CorporateEvents.vue') },
    ]
};
